import useCubeItems, { PageType } from '../hooks/useCubeItems/useCubeItems'
import CubePageTemplate from '../CubePageTemplate/CubePageTemplate'
import { useParams } from 'react-router-dom'
import wahlkreisData from '../hooks/useCubeItems/kandi/wahlkreisData'

const Kandi = () => {
  const { wahlkreisID } = useParams()
  const items = useCubeItems(PageType.KANDI, wahlkreisID)
  const kandi = wahlkreisData['wk' + wahlkreisID]

  return <CubePageTemplate items={items} showVideoPopup gender={!!kandi ? kandi.gender : null} />
}

export default Kandi
